import { DEBUG_ALERT_MSG } from '../config'
import { throttle } from './schedulers'
import { getAllMultitabTokens } from './establishMultitabRole'
import { IS_MULTITAB_SUPPORTED } from './windowEnvironment'
import { captureException, captureMessage } from '../sentry'

window.addEventListener('error', handleErrorEvent)
window.addEventListener('unhandledrejection', handleErrorEvent)

function handleErrorEvent(e: ErrorEvent | PromiseRejectionEvent) {
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  if (e instanceof ErrorEvent && e.message === 'ResizeObserver loop limit exceeded') {
    return
  }

  if (e instanceof ErrorEvent) {
    if (e.error instanceof Error) {
      captureException(e.error)
    } else {
      captureMessage(e.message ?? 'Unknown error in main thread', 'error')
    }
  } else {
    captureException(e.reason ?? 'Unknown unhandled rejection in main thread')
  }

  e.preventDefault()

  handleError(e instanceof ErrorEvent ? e.error || e.message : e.reason)
}

const throttledAlert = throttle((message: string) => {
  if (IS_MULTITAB_SUPPORTED && getAllMultitabTokens().length > 1) {
    return
  }
  // eslint-disable-next-line no-alert
  window.alert(message)
}, 1000)

export function handleError(err: Error) {
  // eslint-disable-next-line no-console
  console.error(err)

  if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging') {
    throttledAlert(`${DEBUG_ALERT_MSG}\n\n${err?.message || err}\n${err?.stack}`)
  }
}
